export const logo = [
  "608 134",
  `
  <title>MAAFOS</title>

`,
];
